export default {
  GROUPS: {
    LAYOUT: 'LayoutGroup',
    INPUT: 'InputGroup',
    SELECT: 'SelectGroup',
    BUTTON: 'ButtonGroup'
  },
  ELEMENTS: {
    LAYOUT: 'Layout',
    INPUT: 'Input',
    TEXTAREA: 'Textarea',
    PHONE: 'Phone',
    PASSWORD: 'Password',
    RADIO: 'Radio',
    CHECKBOX: 'Checkbox',
    SELECT: 'Select',
    TIMEPICKER: 'TimePicker',
    TIMEPICKERMULTIPLE: 'TimePickerMultiple',
    DATEPICKER: 'DatePicker',
    DATEPICKERMULTIPLE: 'DatePickerMultiple',
    RATE: 'Rate',
    SWITCH: 'Switch',
    INPUTNUMBER: 'InputNumber',
    LINK: 'Link',
    DIVIDER: 'Divider'
  },
  SETTINGS: {
    HIDELABEL: 'hideLabel',
    LABELWIDTH: 'labelWidth',
    LABELSUFFIX: 'labelSuffix',
    LABELPOSITION: 'labelPosition',
    SIZE: 'size',
    REQUIREDASTERISK: 'showRequiredAsterisk',
    VERIFYMSG: 'showVerificationMessage'
  },
  ACTIONS: {
    SHOWJSON: 'showJson',
    SHOWPREVIEW: 'showPreview'
  }
}
